import React from 'react';
import classNames from 'classnames';

export interface Column<T> {
  key: string;
  title: React.ReactNode;
  render?: (item: T) => React.ReactNode;
  width?: string | number;
}

export interface TableProps<T> {
  data: T[];
  columns: Column<T>[];
  /** Called with each item and its 0-based index to produce a stable React key. */
  rowKey: (item: T, index: number) => string;
  className?: string;
  onRowClick?: (item: T) => void;
}

export function Table<T>({
  data,
  columns,
  rowKey,
  className,
  onRowClick
}: TableProps<T>) {
  return (
    <div className={classNames('table-container', className)} style={{ overflowX: 'auto' }}>
      <table className="table is-fullwidth is-hoverable">
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col.key} style={{ width: col.width }}>
                {col.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: 'center', padding: '24px' }}>
                No data available
              </td>
            </tr>
          ) : (
            data.map((item, index) => (
              <tr 
                key={rowKey(item, index)} 
                onClick={() => onRowClick?.(item)}
                style={{ cursor: onRowClick ? 'pointer' : 'default' }}
              >
                {columns.map(col => (
                  <td key={col.key}>
                    {col.render ? col.render(item) : (item as any)[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
